import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../../Kryzen Alpha App/Components/Functions/date.fun";
import CustomViewButton from "../../CustomComponent/custom_view_button";
import { FaCheckCircle } from "react-icons/fa";
import { FaCircleXmark } from "react-icons/fa6";
import Stars from "react-stars";
const tableHead = [
  "Sr.",
  "Full Name",
  "Mobile Number",
  "Source Platform / Date",
  "Customer Stage",
  "Lead Stage Status",
  "Executive / Closer",
  "Actions",
];

const LeadMastertable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/leads-master-view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.full_name || "N/A"}</td>
                <td>{item?.mobile_number || "N/A"}</td>
                <td>
                  {item?.source_platform || "N/A"}

                  <hr className="m-0 p-0" />

                  {item?.first_enquiry_date
                    ? new Date(item.first_enquiry_date).toLocaleString(
                        "en-IN",
                        {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        }
                      )
                    : "N/A"}
                </td>
                <td>
                  {Array.isArray(item?.customer_stage)
                    ? item.customer_stage.join(", ")
                    : item?.customer_stage || "N/A"}
                </td>
                <td>{item?.lead_stage_status || "N/A"}</td>
                <td>
                  {item?.lead_stage_status == "Closer"
                    ? item?.last_closer_name
                    : item?.last_executive_name || "N/A"}
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default LeadMastertable;
